import React from 'react';
import NumberFormat from 'react-number-format';
import { PhoneNumberFormats, PhoneNumberTypes } from '../../../lib/constants';
import FadeOutErrorMessage from '../util/FadeOutErrorMessage';

const israeliTwoDigitCodes = ['02', '03', '04', '08', '09'];

export default class ValidatedPhoneInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            phoneNumber: props.phoneNumber,
            phoneType: props.phoneType,
            format: this.getPhoneFormat(props.phoneNumber, props.phoneType),
            requiredError: !props.phoneNumber
        };
    }

    getPhoneFormat = (phoneNumber, phoneType) => {
        switch(phoneType) {
            case PhoneNumberTypes.American:
                return PhoneNumberFormats.american.format;
            case PhoneNumberTypes.Israeli: 
                const number = phoneNumber.replace(/\D/g, '');
                if (number && israeliTwoDigitCodes.indexOf(number.substring(0, 2)) < 0) {
                    return PhoneNumberFormats.israeliCell.format;
                } else {
                    return PhoneNumberFormats.israeliHouse.format;
                }
            default:
                return "";
        }
    }

    update = (name, val) => {
        let format = this.state.format;
        let value = val;
        switch (name) {
            case "phoneType":
                format = this.getPhoneFormat(this.state.phoneNumber, value);
                break;
            case "phoneNumber":
                if (this.state.phoneType === PhoneNumberTypes.Israeli && value.value.length >= 2) {
                    format = this.getPhoneFormat(value.value, this.state.phoneType);
                }
                
                value = value.formattedValue;
                break;
            default:
                break;
        }

        this.setState({
            [name]: value,
            format
        }, () => {
            if(name === "phoneType" || this.props.error) {
                this.validatePhoneNumber(this.state.phoneNumber);
            }
            this.props.onChange(name === "phoneNumber" ? this.props.phoneNumberName : this.props.phoneTypeName, value)
        });
    }

    checkRequire = (value) => {
        if (this.props.required) {
            this.setState({ requiredError: !value });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.phoneNumber !== this.state.phoneNumber) {
            this.setState({
                phoneNumber: nextProps.phoneNumber
            });
            this.checkRequire(nextProps.phoneNumber);
        }

        if(nextProps.phoneType !== this.state.phoneType) {
            this.setState({
                phoneType: nextProps.phoneType,
                format: this.getPhoneFormat(nextProps.phoneNumber, nextProps.phoneType)
            });
        }
    }

    validatePhoneNumber = (val) => {
        if (!val) return;

        const phoneNumber = val.replace(/\D/g, '');
        switch (this.state.phoneType) {
            case PhoneNumberTypes.American:
                this.validateAndSetError(phoneNumber, PhoneNumberFormats.american.length);
                return;
            case PhoneNumberTypes.Israeli:
                if (this.state.format === PhoneNumberFormats.israeliHouse.format) {
                    this.validateAndSetError(phoneNumber, PhoneNumberFormats.israeliHouse.length);
                } else if (this.state.format === PhoneNumberFormats.israeliCell.format) {
                    this.validateAndSetError(phoneNumber, PhoneNumberFormats.israeliCell.length);
                }
                return;
            case PhoneNumberTypes.Other:
                this.validateAndSetError(phoneNumber, 7);
                return;
            default:
                return;
        }
    }

    validateAndSetError = (val, length) => {
        if (!this.props.updateError) return;

        if (val.length < length) {
            this.props.updateError(this.props.errorName, true);
        } else {
            this.props.updateError(this.props.errorName, false);
        }
    }

    onBlur = () => {
        if (this.state.phoneNumber !== '') {
            this.validatePhoneNumber(this.state.phoneNumber );
        } else if (this.props.updateError) {
            this.props.updateError(this.props.errorName, false);
        }
    }

    render() {
        const { error, label, span1, span2, showRequiredError, tabIndex } = this.props;
        const { format, phoneNumber, phoneType, requiredError } = this.state;
        const requiredErr = showRequiredError && requiredError;

        return (
            <div className="modal-row">
                <div className="phone-select flex">
                    <div>
                        <label className="input-label">Phone Type</label>
                        <div className="custom-select">
                            <select name="phoneType" value={phoneType}
                                onChange={e => this.update(e.target.name, e.target.value)}>
                                {Object.keys(PhoneNumberTypes).map(key => 
                                    <option key={key} value={PhoneNumberTypes[key]}>{key}</option>)}
                            </select>
                            <i className="icon ion-ios-arrow-down" />
                        </div>
                    </div>
                    <div className="phone-input">
                        <label className={(error || requiredErr) ? "input-label error-label" : "input-label"}>{label || 'Phone'} {span1} {span2}</label>
                        {phoneType !== "Other"
                            ? <NumberFormat tabIndex={tabIndex || ''}
                                mask="_"
                                placeholder={format}
                                format={format}
                                className={error || requiredErr ? "error-input" : ""}
                                name="phoneNumber"
                                value={phoneNumber}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                onValueChange={values => this.update("phoneNumber", values)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' && this.props.onSubmit)
                                        this.props.onSubmit();
                                }} />
                            : <NumberFormat tabIndex={tabIndex || ''} 
                                format="####################" 
                                name="phoneNumber" 
                                value={phoneNumber} className={error || requiredErr ? "error-input" : ""}
                                onValueChange={values => this.update("phoneNumber", values)} 
                                onFocus={this.onFocus}
                                onBlur={this.onBlur} />}
                        <FadeOutErrorMessage show={error} message='Please enter a valid phone number.' />
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/commonComponents/util/ValidatedPhoneInput.jsx